import React, { useContext, useEffect, useState, useRef } from 'react'
import PiperChart from './PiperChart'
import { DataContext } from './DataContext'
import FilterModeSelector from '../box-plot/FilterModeSelector'
import PiperHeader from './PiperHeader'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'
import Legend from './diagram-builder/Legend'

//https://2019.wattenberger.com/blog/react-and-d3#sizing-responsivity
const PiperChartWrapper = () => {
    const {
        chartRef,
        filterMode,
        setFilterMode,
        displayFilterModeDropdown,
        setDisplayFilterModeDropdown,
        isCollapsed,
        setContainerDimensions,
        piperLegendData,
        saveAsImageRef,
    } = useContext(DataContext)
    const { isExpanded } = useContext(PanelStyleContext)

    const chartHeaderRef = useRef(null)
    const [headerHeight, setHeaderHeight] = useState(0)
    useEffect(() => {
        if (!chartHeaderRef.current) return

        const updateHeaderHeight = () => {
            setHeaderHeight(chartHeaderRef.current.offsetHeight || 0)
        }

        updateHeaderHeight()

        const resizeObserver = new ResizeObserver(updateHeaderHeight)
        resizeObserver.observe(chartHeaderRef.current)

        return () => {
            if (chartHeaderRef.current) {
                resizeObserver.unobserve(chartHeaderRef.current)
            }
        }
    }, [])

    useEffect(() => {
        const container = chartRef.current
        if (!container) return

        setContainerDimensions({
            width: isExpanded ? container.clientWidth : 600,
            height: isExpanded ? container.clientHeight - headerHeight : 600,
        })
    }, [isExpanded, headerHeight])

    return (
        <div
            className={`dashboardPanelBody ${
                isCollapsed ? 'is-collapsed' : ''
            }`}
        >
            <div ref={chartHeaderRef}>
                <FilterModeSelector
                    displayFilterModeDropdown={displayFilterModeDropdown}
                    setDisplayFilterModeDropdown={setDisplayFilterModeDropdown}
                    setFilterMode={setFilterMode}
                    filterMode={filterMode}
                />
            </div>
            <div ref={saveAsImageRef} className={`piperWrapper`}>
                <div
                    ref={chartRef}
                    style={{
                        height: '90%',
                    }}
                >
                    <PiperChart isExpanded={isExpanded} />
                </div>
                <Legend legendItems={piperLegendData} />
            </div>
        </div>
    )
}

export default PiperChartWrapper
